import { required, Validator } from '@/entities/validation';
import { Sensor } from './model';

export const validate: Validator<Sensor> = sensor => [
  ...required(sensor.title, 'title'),
  ...required(sensor.hardwareId, 'hardwareId'),
  ...required(sensor.entityItem ? sensor.entityItem.toString() : '', 'entityItem'),
];
